/* eslint-disable @typescript-eslint/no-unsafe-function-type */
import { useEffect, useState, JSX } from 'react';
import { useTheme } from 'styled-components';
import DataTable from '../../juristec-ui/core/DataTable';
import {
  CollapsibleContainer, ExtraInfos, ExtraItens, GroupsTableContainer, GroupsTableOverFlow, IconFlipWrapper, Options, UserInfoContainer, UserInfoText, UsersContainer, UsersHeader,
} from './styled/GroupsTable.styled';
import { formatDateTime } from '../../juristec-ui/utils/functions/lab';
import Tooltip from '../../juristec-ui/core/Tooltip';
import IconButton from '../../juristec-ui/core/IconButton/IconButton';
import {
  Edit, ExpandMore, Trash, Users,
} from '../../juristec-ui/icons';
import { Group, User } from '../../types';

interface Props {
  groups: Group[];
  onEdit: (group: Group) => void;
  onDelete: (group: Group) => void;
  users: User[];
  filterText?: string;
  openUsersModal: (group: Group) => void;
}

const GroupsTable = ({
  groups, onEdit, onDelete, users, filterText = '', openUsersModal = () => {},
}: Props) => {
  const theme = useTheme();

  const groupContainer = (open: boolean, group: Group) => (
    // @ts-expect-error not typed yet
    <CollapsibleContainer control={open} maxSize={300}>
      <ExtraInfos>
        <ExtraItens>
          <h2>Descrição:</h2>
          <p>{group.description}</p>
        </ExtraItens>
      </ExtraInfos>
    </CollapsibleContainer>
  );

  const [showExtra, setShowExtra] = useState<Record<string, boolean>>({});
  const [rowData, setRowData] = useState<
  Record<string, JSX.Element | string | boolean | Function | Date
  >[]>([]);

  const handleExtraContent = (toggle: boolean, key: string) => {
    setShowExtra((old) => ({
      ...old,
      [key]: toggle,
    }));
  };

  useEffect(() => setRowData(
    groups.reduce(
      (
        aux: Record<string, JSX.Element | string | boolean | Function | Date>[], group: Group,
      ) => {
        if (filterText && !group.name.toLowerCase().includes(filterText.toLocaleLowerCase())) {
          return aux;
        }
        aux.push({
          ...group,
          moreContent: groupContainer(!!showExtra[group.id], group),
          showMoreContent: !!showExtra[group.id],
          toggleMoreContent: (toggle: boolean) => handleExtraContent(toggle, group.id),
        });
        return aux;
      }, [],
    ),
  ), [groups, showExtra, filterText]);
  const columns = [
    {
      field: 'flipper',
      label: '',
      valueGetter: (param: Group) => (
        // @ts-expect-error not typed yet
        <IconFlipWrapper flip={param.showMoreContent}>
          <ExpandMore />
        </IconFlipWrapper>
      ),
    },
    { field: 'name', label: 'Nome', sortable: true },
    {
      field: 'created_by',
      label: 'Criado por',
      valueGetter: (group: Group) => {
        const userFound = users.find((u: User) => u.uid === group.created_by);
        return userFound ? userFound.name : '';
      },
      sortable: true,
    },
    {
      field: 'created_at',
      label: 'Data de criação',
      valueGetter: (group: Group) => formatDateTime(group.created_at),
      sortable: true,
    },

    {
      field: 'updated_by',
      label: 'Atualizado por',
      valueGetter: (group: Group) => {
        const userFound = users.find((u: User) => u.uid === group.updated_by);
        return userFound ? userFound.name : '';
      },
      sortable: true,
    },
    {
      field: 'updated_at',
      label: 'Data de atualização',
      valueGetter: (group: Group) => formatDateTime(group.updated_at),
      sortable: true,
    },
    {
      field: 'actions',
      label: '',
      valueGetter: (group: Group) => (
        <Options>
          <Tooltip text="Visualizar usuários">
            <IconButton
              // @ts-expect-error not typed yet
              onClick={
                (e: MouseEvent) => {
                  e.stopPropagation();
                  openUsersModal(group);
                }
              }
              variant="pattern"
              shape="rounded"
              color="primary"
            >
              <Users />
            </IconButton>
          </Tooltip>
          <Tooltip text="Editar grupo">
            <IconButton
              // @ts-expect-error not typed yet
              onClick={
                (e: MouseEvent) => {
                  e.stopPropagation();
                  onEdit(group);
                }
              }
              variant="pattern"
              shape="rounded"
              color="primary"
            >
              <Edit />
            </IconButton>
          </Tooltip>
          <Tooltip text="Deletar grupo">
            <IconButton
              // @ts-expect-error not typed yet
              onClick={
                (e: MouseEvent) => {
                  e.stopPropagation();
                  onDelete(group);
                }
              }
              variant="pattern"
              shape="rounded"
              color="primary">
              <Trash />
            </IconButton>
          </Tooltip>
        </Options>
      ),
    },
  ];

  return (
    <GroupsTableContainer>
      <GroupsTableOverFlow>
        <DataTable
          columns={columns}
          rowData={rowData}
          // @ts-expect-error not typed yet
          strippedRowsColor={theme.containerOdd}
          defaultSortField="name"
          defaultSortOrder="ascending"
          // @ts-expect-error not typed yet
          headerColor="transparent"
          // @ts-expect-error not typed yet
          rowColor={theme.tableBackground}
          // @ts-expect-error not typed yet
          theadStyle={{
            position: 'sticky',
            top: 0,
            zIndex: 1,
            // @ts-expect-error not typed yet
            backgroundColor: theme.background,
          }}
          expandRow
        />
      </GroupsTableOverFlow>
    </GroupsTableContainer>
  );
};

export default GroupsTable;
